"use client";

import React, { useState, useEffect } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import {
  Heart,
  Facebook,
  Twitter,
  Instagram,
  Youtube,
  Phone,
  Mail,
  MapPin,
} from "lucide-react";
import { getWithoutTokenAPI } from "../util/Api";
import {
  AlertDialog,
  AlertDialogContent,
  AlertDialogHeader,
  AlertDialogFooter,
  AlertDialogTitle,
  AlertDialogDescription,
  AlertDialogCancel,
  AlertDialogAction,
} from "./ui/alert-dialog";
import { useDispatch, useSelector } from "react-redux";
import { setCurrentPage } from "../redux/navigationSlice.js";
import AOS from "aos";
import "aos/dist/aos.css";
import { useTranslation } from "react-i18next";
import TermsAndConditions from "./TermsAndConditions.jsx";
import defaultLogo from "../assets/logo.png";

export function Footer({ onNavigate }) {
  const [footer, setFooter] = useState(null);
  const [showLoginDialog, setShowLoginDialog] = useState(false);
  const dispatch = useDispatch();
  const data = useSelector((state) => state.user);
  const token = data?.userId?.accessToken;
  const { t, i18n } = useTranslation();
  const navigate = useNavigate();
  const location = useLocation();

  const getLinkClass = (path) => {
    const isActive = location.pathname === path;
    return `hover:text-red-400 transition-colors cursor-pointer text-left ${isActive ? "text-red-500 font-medium" : ""}`;
  };

  const officeaddress = i18n.language === 'en' ?
    footer?.OfficeAddress?.en : (footer?.OfficeAddress?.ta || footer?.OfficeAddress?.en);
  useEffect(() => {
    const fetchFooter = async () => {
      try {
        const response = await getWithoutTokenAPI(`/footer/get_all`);
        if (response?.data?.length) {
          setFooter(response.data[0]);
        }
      } catch (error) {
        console.error("Error fetching footer:", error);
      }
    };
    fetchFooter();
  }, []);

  if (!footer) return null;

  return (
    <footer className="bg-primary text-primary-foreground">
      <div className="max-w-8xl mx-auto px-4 sm:px-6 lg:px-8 py-12">
        <div className="grid grid-cols-1 md:grid-cols-4 gap-8">
          {/* Brand Info */}
          <div>
            <div className="flex items-center space-x-2 mb-4">
              {footer?.brandInfo?.logo ? (
                <div className="p-2 rounded-lg shadow-sm">
                  <img
                    src={footer?.brandInfo?.logo}
                    alt="Aishwarya matrimony Logo"
                    className="w-auto object-contain"
                    style={{ width: "120px" }}
                    onError={(e) => { e.target.onerror = null; e.target.src = defaultLogo; }}
                  />
                </div>
              ) : (
                <div className="bg-white p-2 rounded-lg shadow-sm">
                  <img src={defaultLogo} alt="Aishwarya matrimony Logo" className="h-20 md:h-24 w-auto object-contain" />
                </div>
              )}
              {/* <span className="text-xl font-semibold">
                {"" || footer?.brandInfo?.brandName}
              </span> */}
            </div>
            <p className="text-primary-foreground/80 mb-4">
              {t("Your journey to finding the right Tamil partner begins with Aishwarya matrimony.")}

            </p>
               <h4 className="mb-4 font-semibold">{t("Follow Us")}</h4>
            <div className="flex space-x-4">
              {footer?.socialMedia?.facebook && (
                <a
                  href={footer.socialMedia.facebook}
                  target="_blank"
                  rel="noreferrer"
                >
                  <Facebook className="h-5 w-5 hover:text-red-400 cursor-pointer transition-colors" />
                </a>
              )}
              {footer?.socialMedia?.twitter && (
                <a
                  href={footer.socialMedia.twitter}
                  target="_blank"
                  rel="noreferrer"
                >
                  <Twitter className="h-5 w-5 hover:text-red-400 cursor-pointer transition-colors" />
                </a>
              )}
              {footer?.socialMedia?.instagram && (
                <a
                  href={footer.socialMedia.instagram}
                  target="_blank"
                  rel="noreferrer"
                >
                  <Instagram className="h-5 w-5 hover:text-red-400 cursor-pointer transition-colors" />
                </a>
              )}
              {footer?.socialMedia?.youtube && (
                <a
                  href={footer.socialMedia.youtube}
                  target="_blank"
                  rel="noreferrer"
                >
                  <Youtube className="h-5 w-5 hover:text-red-400 cursor-pointer transition-colors" />
                </a>
              )}
              {footer?.is_threads_active && footer?.socialMedia?.threads && (
                <a
                  href={footer.socialMedia.threads}
                  target="_blank"
                  rel="noreferrer"
                  className="hover:text-red-400 cursor-pointer transition-colors"
                >
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    viewBox="0 0 192 192"
                    className="h-5 w-5"
                    fill="currentColor"
                    aria-label="Threads"
                  >
                    <path d="M141.537 88.988a66.667 66.667 0 0 0-2.518-1.143c-1.482-27.307-16.403-42.94-41.457-43.1h-.34c-14.986 0-27.449 6.396-35.12 18.036l13.779 9.452c5.73-8.695 14.724-10.548 21.348-10.548h.23c8.248.054 14.474 2.452 18.502 7.13 2.932 3.405 4.893 8.11 5.864 14.05-7.314-1.244-15.224-1.626-23.68-1.14-23.82 1.372-39.134 15.265-38.105 34.569.522 9.792 5.4 18.216 13.735 23.719 7.047 4.652 16.124 6.927 25.557 6.412 12.458-.683 22.231-5.436 29.049-14.127 5.178-6.6 8.453-15.153 9.899-25.93 5.937 3.583 10.337 8.298 12.767 13.966 4.132 9.635 4.373 25.468-8.546 38.376-11.319 11.308-24.925 16.2-45.488 16.35-22.809-.169-40.06-7.484-51.275-21.741C35.236 139.966 29.808 120.682 29.605 96c.203-24.682 5.63-43.966 16.133-57.317C56.954 24.425 74.206 17.11 97.015 16.94c22.975.17 40.526 7.52 52.171 21.847 5.71 7.026 10.015 15.86 12.853 26.162l16.147-4.308c-3.44-12.68-8.853-23.606-16.219-32.668C147.04 9.607 125.96.195 97.19 0h-.38C68.112.195 47.313 9.638 33.139 28.044 20.648 44.489 14.23 67.638 14.01 96v.04c.22 28.363 6.638 51.512 19.129 67.957C47.313 182.361 68.112 191.804 96.81 192h.38c25.902-.189 44.028-6.967 58.056-21.004 19.49-19.463 18.844-43.921 12.447-58.967-4.653-10.854-13.562-19.684-26.156-25.041ZM98.44 129.507c-10.44.588-21.286-4.098-21.82-14.135-.397-7.442 5.286-15.746 22.462-16.735 1.966-.113 3.895-.169 5.79-.169 6.235 0 12.068.606 17.37 1.765-1.977 24.702-13.58 28.713-23.802 29.274Z"/>
                  </svg>
                </a>
              )}
            </div>
            <p className="text-primary-foreground/60 mb-4">
              {footer?.brandInfo?.yearsActive}
            </p>
          </div>

          {/* Quick Links */}
          <div>
            <h4 className="mb-4 font-semibold">{t("Quick Links")}</h4>
            <ul className="space-y-2 text-primary-foreground/80">
              <li>
                <button
                  onClick={() => {
                    window.scrollTo({ top: 0, behavior: "smooth" })
                    navigate("/browse")
                  }}
                  className={getLinkClass("/browse")}
                >
                  {t("Browse")}
                </button>
              </li>
              <li>
                <button
                  onClick={
                    token
                      ? () => { window.scrollTo({ top: 0, behavior: "smooth" }); navigate("/matches") }
                      : () => setShowLoginDialog(true)
                  }
                  className={getLinkClass("/matches")}
                >
                  {t("Matches")}
                </button>
              </li>
              <li>
                <button
                  onClick={
                    token
                      ? () => { window.scrollTo({ top: 0, behavior: "smooth" }); navigate("/messages") }
                      : () => setShowLoginDialog(true)
                  }
                  className={getLinkClass("/messages")}
                >
                  {t("Messages")}
                </button>
              </li>
              <li>
                <button
                  onClick={() => { window.scrollTo({ top: 0, behavior: "smooth" }); navigate("/subscription") }}
                  className={getLinkClass("/subscription")}
                >
                  {t("Subscription")}
                </button>
              </li>
              <li>
                <button
                  onClick={
                    token
                      ? () => { window.scrollTo({ top: 0, behavior: "smooth" }); navigate("/profile") }
                      : () => setShowLoginDialog(true)
                  }
                  className={getLinkClass("/profile")}
                >
                  {t("Profile")}
                </button>
              </li>
              <li>
                <button
                  onClick={() => { window.scrollTo({ top: 0, behavior: "smooth" }); navigate("/contact") }}
                  className={getLinkClass("/contact")}
                >
                  {t("Contact Us")}
                </button>
              </li>
            </ul>
          </div>

          {/* Legal Links */}
          <div>
            <h4 className="mb-4 font-semibold">{t("Legal")}</h4>
            <ul className="space-y-2 text-primary-foreground/80">
              <li>
                <button
                  onClick={() => { window.scrollTo({ top: 0, behavior: "smooth" }); navigate("/t&c") }}
                  className={getLinkClass("/t&c")}
                >
                  {t("Terms of Services")}
                </button>
              </li>
              <li>
                <button
                  onClick={() => { window.scrollTo({ top: 0, behavior: "smooth" }); navigate("/privacy") }}
                  className={getLinkClass("/privacy")}
                >
                  {t("Privacy Policy")}
                </button>
              </li>
              <li>
                <button
                  onClick={() => { window.scrollTo({ top: 0, behavior: "smooth" }); navigate("/cancellation") }}
                  className={getLinkClass("/cancellation")}
                >
                  Cancellation & Refund Policy
                </button>
              </li>
              <li>
                <button
                  onClick={() => { window.scrollTo({ top: 0, behavior: "smooth" }); navigate("/shipping") }}
                  className={getLinkClass("/shipping")}
                >
                  Shipping & Exchange Policy
                </button>
              </li>
            </ul>
          </div>

          {/* Contact Info */}
          <div>
            <h4 className="mb-4 font-semibold">{t("Contact Us")}</h4>
            <div className="space-y-3 text-primary-foreground/80">
              <div className="flex items-start space-x-3">
                <Phone className="h-4 w-4 mt-1 text-red-400" />
                <div>
                  <p className="font-medium">{t("Phone Number")}</p>
                  <p className="hover:text-red-400 transition-colors cursor-pointer">
                    {footer?.PhoneNumber}
                  </p>
                </div>
              </div>
              <div className="flex items-start space-x-3">
                <Mail className="h-4 w-4 mt-1 text-red-400" />
                <div>
                  <p className="font-medium">{t("Email Address")}</p>
                  <p className="hover:text-red-400 transition-colors cursor-pointer">
                    {footer?.EmailAddress}
                  </p>
                </div>
              </div>
              {footer?.OfficeAddress && officeaddress && <div className="flex items-start space-x-3">
                <MapPin className="w-4 h-4 mt-1 text-red-600" />
                <div>
                  <p className="font-medium">{t("Office Address")}</p>
                  <p className="text-sm">
                    {officeaddress}
                  </p>
                </div>
              </div>}
            </div>
          </div>

          {/* Social Links */}
          {/* <div>
         
          </div> */}
        </div>

        {/* Copyright */}
        <div className="border-t border-primary-foreground/20 mt-8 pt-8 text-center text-primary-foreground/60">
          <p>
            {footer?.copyright || "© 2026 Aishwarya matrimony"} |{" "}
            <span className="inline-flex items-center gap-1">
              Powered by{" "}
              <a className="cursor-pointer hover:text-red-400" href="https://prosperoustech.com/" target="_blank" rel="noreferrer">
                ProsperousTech
              </a>
            </span>
          </p>
        </div>
      </div>

      <AlertDialog open={showLoginDialog} onOpenChange={setShowLoginDialog}>
        <AlertDialogContent>
          <AlertDialogHeader>
            <AlertDialogTitle>{t("You’re Almost There!")}</AlertDialogTitle>
            <AlertDialogDescription>
              {t("Log in to explore profiles and start connecting")}
            </AlertDialogDescription>
          </AlertDialogHeader>
          <AlertDialogFooter>
            <AlertDialogCancel
              onClick={() => setShowLoginDialog(false)}
              className="cursor-pointer"
            >
              {t("Cancel")}
            </AlertDialogCancel>
            <AlertDialogAction
              className="text-white cursor-pointer"
              style={{ background: 'linear-gradient(to right bottom, rgb(220, 38, 38), rgb(243, 67, 67))' }}
              onClick={() => {
                setShowLoginDialog(false);
                dispatch(setCurrentPage("login"));
              }}
            >
              {t("Login")}
            </AlertDialogAction>
          </AlertDialogFooter>
        </AlertDialogContent>
      </AlertDialog>
    </footer>
  );
}
